import React, { useEffect, useState } from 'react';
import { Menu, X, Instagram, Facebook } from 'lucide-react';
import { Button } from './ui/Button';
import { Logo } from './ui/Logo';
import { TikTokIcon } from './ui/TikTokIcon';
import { useLanguage } from '../i18n/LanguageContext';
const TIKTOK_URL = 'https://www.tiktok.com/@riam_beautystudio?_r=1&_t=ZP-96pg2zAAtKw';
export function Header() {
  const {
    t,
    lang,
    setLang
  } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    document.body.style.overflow = isMobileMenuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [isMobileMenuOpen]);
  const navLinks = [{
    name: t.nav.inicio,
    href: '#inicio'
  }, {
    name: t.nav.galeria,
    href: '#galeria'
  }, {
    name: t.nav.servicios,
    href: '#servicios'
  }, {
    name: t.nav.historia,
    href: '#historia'
  }, {
    name: t.nav.testimonios,
    href: '#testimonios'
  }, {
    name: t.nav.contacto,
    href: '#contacto'
  }];
  return <>
      <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-riam-black/95 backdrop-blur-md py-3 shadow-lg shadow-black/50' : 'bg-transparent py-5'}`} data-id="element-131">
        <div className="container mx-auto px-4 md:px-6 flex items-center justify-between" data-id="element-132">
          {/* Logo */}
          <a href="#inicio" className="relative z-[60] flex-shrink-0" data-id="element-133">
            <Logo size="sm" data-id="element-134" />
          </a>

          {/* Desktop Nav */}
          <nav className="hidden xl:flex items-center space-x-8" data-id="element-135">
            {navLinks.map(link => <a key={link.name} href={link.href} className="gold-shine text-sm font-sans tracking-widest uppercase hover:opacity-80 transition-opacity" data-id="element-136">
                {link.name}
              </a>)}
          </nav>

          {/* Desktop Actions */}
          <div className="hidden xl:flex items-center space-x-6" data-id="element-137">
            <div className="flex items-center space-x-4" data-id="element-138">
              <a href="https://www.instagram.com/riam_beautystudio/" target="_blank" rel="noreferrer" className="icon-glow hover:opacity-80 transition-opacity" aria-label="Instagram @riam_beautystudio" data-id="element-139">
                <Instagram size={20} stroke="url(#riamGold)" data-id="element-140" />
              </a>
              <a href="https://www.facebook.com/rosanaisabelanazcomartinez" target="_blank" rel="noreferrer" className="icon-glow hover:opacity-80 transition-opacity" aria-label="Facebook Rosana Isabel Añazco Martinez" data-id="element-141">
                <Facebook size={20} stroke="url(#riamGold)" data-id="element-142" />
              </a>
              <a href={TIKTOK_URL} target="_blank" rel="noreferrer" className="icon-glow hover:opacity-80 transition-opacity" aria-label="TikTok @riam_beautystudio" data-id="element-143">
                <TikTokIcon size={20} data-id="element-144" />
              </a>
            </div>
            <div className="flex items-center space-x-2 border-l border-riam-gold/20 pl-6 ml-2" data-id="element-145">
              <button onClick={() => setLang('es')} className={`text-xs font-sans tracking-widest uppercase transition-colors ${lang === 'es' ? 'text-riam-gold font-bold' : 'text-riam-gold-light/50 hover:text-riam-gold-light'}`} data-id="element-146">
                ES
              </button>
              <span className="text-riam-gold-light/30 text-xs" data-id="element-147">|</span>
              <button onClick={() => setLang('en')} className={`text-xs font-sans tracking-widest uppercase transition-colors ${lang === 'en' ? 'text-riam-gold font-bold' : 'text-riam-gold-light/50 hover:text-riam-gold-light'}`} data-id="element-148">
                EN
              </button>
            </div>
            <Button href="https://beautybyriam.booksy.com" className="px-6 py-2.5 text-xs" data-id="element-149">
              {t.nav.reservarCorto}
            </Button>
          </div>

          {/* Mobile right cluster — social icons + lang toggle + hamburger */}
          <div className="xl:hidden flex items-center space-x-3 sm:space-x-4" data-id="element-150">
            <a href="https://www.instagram.com/riam_beautystudio/" target="_blank" rel="noreferrer" className="hidden sm:inline-flex icon-glow text-riam-gold-light hover:opacity-80 transition-opacity" aria-label="Instagram @riam_beautystudio" data-id="element-151">
              <Instagram size={22} stroke="url(#riamGold)" data-id="element-152" />
            </a>
            <a href="https://www.facebook.com/rosanaisabelanazcomartinez" target="_blank" rel="noreferrer" className="hidden sm:inline-flex icon-glow text-riam-gold-light hover:opacity-80 transition-opacity" aria-label="Facebook Rosana Isabel Añazco Martinez" data-id="element-153">
              <Facebook size={22} stroke="url(#riamGold)" data-id="element-154" />
            </a>
            <a href={TIKTOK_URL} target="_blank" rel="noreferrer" className="hidden sm:inline-flex icon-glow text-riam-gold-light hover:opacity-80 transition-opacity" aria-label="TikTok @riam_beautystudio" data-id="element-155">
              <TikTokIcon size={22} data-id="element-156" />
            </a>

            {/* Compact language toggle */}
            <div className="relative z-[60] flex items-center space-x-1.5 px-2.5 py-1 border border-riam-gold/40 rounded-sm" data-id="element-157">
              <button type="button" onClick={() => setLang('es')} className={`text-[11px] font-sans tracking-widest uppercase transition-colors ${lang === 'es' ? 'text-riam-gold font-bold' : 'text-riam-gold-light/50 hover:text-riam-gold-light'}`} aria-label="Cambiar a español" data-id="element-158">
                ES
              </button>
              <span className="text-riam-gold-light/30 text-[11px]" data-id="element-159">|</span>
              <button type="button" onClick={() => setLang('en')} className={`text-[11px] font-sans tracking-widest uppercase transition-colors ${lang === 'en' ? 'text-riam-gold font-bold' : 'text-riam-gold-light/50 hover:text-riam-gold-light'}`} aria-label="Switch to English" data-id="element-160">
                EN
              </button>
            </div>

            <button type="button" className="relative z-[70] p-2 rounded border border-riam-gold/40 text-riam-gold-light icon-glow" onClick={() => setIsMobileMenuOpen(open => !open)} aria-label={isMobileMenuOpen ? 'Cerrar menú' : 'Abrir menú'} aria-expanded={isMobileMenuOpen} data-id="element-161">
              {isMobileMenuOpen ? <X size={24} strokeWidth={2} data-id="element-162" /> : <Menu size={24} strokeWidth={2} data-id="element-163" />}
            </button>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      <div className={`fixed inset-0 z-[55] bg-riam-black/98 backdrop-blur-xl flex flex-col items-center justify-center transition-all duration-500 xl:hidden ${isMobileMenuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`} aria-hidden={!isMobileMenuOpen} data-id="element-164">
        <nav className="flex flex-col items-center space-y-7 mb-10" data-id="element-165">
          {navLinks.map((link, i) => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="gold-shine text-2xl font-serif tracking-wide transition-all duration-500" style={{
          transitionDelay: isMobileMenuOpen ? `${i * 70}ms` : '0ms',
          transform: isMobileMenuOpen ? 'translateY(0)' : 'translateY(20px)',
          opacity: isMobileMenuOpen ? 1 : 0
        }} data-id="element-166">
              {link.name}
            </a>)}
        </nav>

        <div className="gold-divider w-32 mb-8" data-id="element-167" />

        <div className="flex items-center space-x-8 mb-10" data-id="element-168">
          <a href="https://www.instagram.com/riam_beautystudio/" target="_blank" rel="noreferrer" className="icon-glow-strong text-riam-gold-light hover:scale-110 transition-transform" aria-label="Instagram @riam_beautystudio" data-id="element-169">
            <Instagram size={28} stroke="url(#riamGold)" data-id="element-170" />
          </a>
          <a href="https://www.facebook.com/rosanaisabelanazcomartinez" target="_blank" rel="noreferrer" className="icon-glow-strong text-riam-gold-light hover:scale-110 transition-transform" aria-label="Facebook Rosana Isabel Añazco Martinez" data-id="element-171">
            <Facebook size={28} stroke="url(#riamGold)" data-id="element-172" />
          </a>
          <a href={TIKTOK_URL} target="_blank" rel="noreferrer" className="icon-glow-strong text-riam-gold-light hover:scale-110 transition-transform" aria-label="TikTok @riam_beautystudio" data-id="element-173">
            <TikTokIcon size={28} data-id="element-174" />
          </a>
        </div>

        {/* Language selector */}
        <div className="flex items-center space-x-3 mb-10 px-5 py-2.5 border border-riam-gold/30 rounded-sm bg-riam-jet/40 backdrop-blur-sm" data-id="element-175">
          <button type="button" onClick={() => setLang('es')} className={`text-sm font-sans tracking-widest uppercase transition-colors ${lang === 'es' ? 'text-riam-gold font-bold' : 'text-riam-gold-light/50 hover:text-riam-gold-light'}`} data-id="element-176">
            ES
          </button>
          <span className="text-riam-gold-light/30 text-sm" data-id="element-177">|</span>
          <button type="button" onClick={() => setLang('en')} className={`text-sm font-sans tracking-widest uppercase transition-colors ${lang === 'en' ? 'text-riam-gold font-bold' : 'text-riam-gold-light/50 hover:text-riam-gold-light'}`} data-id="element-178">
            EN
          </button>
        </div>

        <Button href="https://beautybyriam.booksy.com" onClick={() => setIsMobileMenuOpen(false)} data-id="element-179">
          {t.nav.reservar}
        </Button>
      </div>
    </>;
}